<div *ngIf="(src$ | async) && placeholder" class="placeholder"></div>
<div *ngIf="!(src$ | async) && icon" class="icon-container">
  <mat-icon>{{ icon }}</mat-icon>
</div>
<img *ngIf="(path$ | async) && !(showOriginalImage$ | async)" [class.show-image]="loaded$ | async" (load)="loaded$.next(true)" [src]="thumbnailSrc$ | async">
<img *ngIf="(!(path$ | async) || (showOriginalImage$ | async)) && (src$ | async)" [class.show-image]="loaded$ | async" (load)="loaded$.next(true)" [src]="src$ | async">
